import React, { useCallback, useState } from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { ReferralsSearch } from './ReferralsSearch';

interface ReferralsListProps {
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  enableSingleSelect?: boolean;
}

export const ReferralsList: React.FC<ReferralsListProps> = ({
  onRowClick,
  enableSingleSelect,
}) => {
  const spd = useSpdCore();
  const [refresh, setRefresh] = useState<boolean>(false);

  const handleClick = useCallback(
    async (id: string) => {
      await spd.support.get(id);
    },
    [spd.support],
  );

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy: string | undefined,
      orderDirection: string | undefined,
      filterText: string | undefined,
    ) =>
      spd.support.getWithPrintsByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        onRefresh,
      ),
    [spd.support],
  );

  return (
    <>
      <ReferralsSearch
        getData={getData}
        getCount={spd.support.getWithPrintsCount}
        onRowClick={onRowClick ? onRowClick : handleClick}
        enableSingleSelect={enableSingleSelect}
        refresh={refresh}
      />
    </>
  );
};
